import { DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';
import { Component, OnInit } from '@angular/core';
import { Injectable } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { Observable } from 'rxjs/Rx';

import { environment } from '../environment';
import { Module } from '../models/module';

declare var $: any; 

@Component({
  selector: 'app-modules',
  templateUrl: './modules.component.html'
})

export class ModulesComponent implements OnInit {

	title: string;
	header: any;
	headerHeight: any;
  headerAlign: any;
	subtitle: string;

  modules: Module;

  constructor(private http      : Http,
              private sanitizer : DomSanitizer ) { }

  getModules(): Promise<Module> {
    return this.http
      .get(`${environment.baseUrl}/data/modules/`,
      {headers: this.getHeaders()})
      .toPromise()
      .then(mapModules)
      .catch(handleError)
    }

    private getHeaders() {
      let headers = new Headers();
      headers.append('Accept', 'application/json');
      return headers;
    }

  /* On with the show */
ngOnInit() {

  	this.title = 'WHAT ARE MODULES?';
    this.header = this.sanitizer.bypassSecurityTrustStyle( 'url( "/assets/img/concept/TownSquare.jpg") 0px 20%' );
  	this.subtitle = 'Identity\'s main three game modes.';
    this.headerHeight = '300px';

    $('.megamenu .image').mousemove(function(e){
      var x = -(e.pageX + this.offsetLeft) / 200;
      var y = -(e.pageY + this.offsetTop) / 200;
      $(this).css('transform','translateY('+ y + '%) translateX('+ x + '%)');
    });

    Promise.resolve(this.getModules()).then(theseModules =>
      this.modules = theseModules
    );

  }

}


function mapModules(response:Response): Module {
  let res = response.json().modules.map(toModules);
  return res;
}

function toModules(r:any): Module {
  let modules = <Module>({
    id: r.id,
    title: r.title,
    type: r.type,
    status: r.status,
    teaser: r.teaser,
    header: r.header,
    description: r.description,
    features: r.features,
    progress: r.progress,
    images: r.images,
    background_image: r.background_image,
    icon: r.icon,
    featured_image : r.featured_image,
    prompt: r.prompt
  });
  return modules;
}



/**
*     Error Handling
**/

// this could also be a private method of the component class
function handleError (error: any) {
  // log error
  // could be something more sofisticated
  let errorMsg = error.message || `Yikes! There was was a problem with our hyperdrive device and we couldn't retrieve your data!`;
  console.error(errorMsg);

  // throw an application level error
  return Observable.throw(errorMsg);
}



// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/app/modules/modules.component.ts